<template>
  <footer class="footer" id="footer-section">
    <div class="footer-container">
      <!-- Top Section: Contact + Social Media -->
      <div class="footer-top">
        <div class="contact-section">
          <h2 class="contact-title">تواصل معنا!</h2>
          <button class="contact-button" @click="handleContactClick">
            <span>إرسال رسالة</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14.43 18.82C14.24 18.82 14.05 18.75 13.9 18.6C13.61 18.31 13.61 17.83 13.9 17.54L19.44 12L13.9 6.46C13.61 6.17 13.61 5.69 13.9 5.4C14.19 5.11 14.67 5.11 14.96 5.4L21.03 11.47C21.32 11.76 21.32 12.24 21.03 12.53L14.96 18.6C14.81 18.75 14.62 18.82 14.43 18.82Z" fill="currentColor"/>
              <path d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z" fill="currentColor"/>
            </svg>
          </button>
        </div>

        <div class="social-media">
          <a
            href="https://www.instagram.com/monglishacademy/"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
          >
            <div class="social-icon instagram">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </div>
            <div class="social-info">
              <div class="social-name">إنستغرام</div>
              <div class="social-handle">monglishacademy/</div>
            </div>
          </a>

          <a
            href="https://x.com/monglish_uk"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
          >
            <div class="social-icon twitter">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </div>
            <div class="social-info">
              <div class="social-name">تويتر</div>
              <div class="social-handle">monglish_uk</div>
            </div>
          </a>

          <a
            href="https://www.youtube.com/@monglishacademy"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
          >
            <div class="social-icon youtube">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </div>
            <div class="social-info">
              <div class="social-name">يوتيوب</div>
              <div class="social-handle">@monglishacademy</div>
            </div>
          </a>

          <a
            href="https://www.linkedin.com/company/monglish-academy/"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
          >
            <div class="social-icon linkedin">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </div>
            <div class="social-info">
              <div class="social-name">لينكد إن</div>
              <div class="social-handle">monglish-academy/</div>
            </div>
          </a>
        </div>
      </div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Footer Links -->
      <div class="footer-links">
        <a href="https://monglish.co.uk/ar/" class="footer-link">منصتنا</a>
        <a href="https://monglish.co.uk/" class="footer-link">برنامج التسويق بالعمولة</a>
        <a href="https://monglish.co.uk/ar/terms-and-conditions/security" class="footer-link">الأمان والحماية</a>
        <a href="https://monglish.co.uk/ar/terms-and-conditions/refund" class="footer-link">الاسترداد وإعادة الجدولة</a>
        <a href="https://monglish.co.uk/ar/terms-and-conditions/terms" class="footer-link">الشروط والأحكام</a>
        <a href="https://monglish.co.uk/ar/terms-and-conditions/privacy" class="footer-link">سياسة الخصوصية</a>
      </div>

      <!-- Bottom Section: Logo + Description -->
      <div class="footer-bottom">
        <img
          src="/monglish.svg"
          alt="أكاديمية مونجلش الدولية"
          class="footer-logo"
          loading="lazy"
        />
        <p class="footer-description">
          أكاديمية مونجلش الدولية هي مؤسسة مسجلة في إنجلترا وويلز (رقم التسجيل 14083316)، مع مقرها القانوني في لندن. تعترف الأكاديمية بشهادات اللغة الإنجليزية الصادرة عن جامعة كامبريدج وتوظف مدربين معتمدين يحملون مؤهلات TKT وCELTA وDELTA.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const handleContactClick = () => {
  console.log('Contact button clicked');
  window.open('https://monglish.co.uk/ar/contact', '_blank');
};
</script>

<style scoped>
.footer {
  width: 100%;
  background: linear-gradient(180deg, #0a2540 0%, #0f0f0f 100%);
  padding: 72px 56px 40px;
  box-sizing: border-box;
  color: #fff;
  font-family: Cairo, Arial, sans-serif;
}

.footer-container {
  max-width: 1463px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 64px;
}

/* Top Section */
.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.contact-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.contact-title {
  font-size: 40px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
  margin: 0;
  color: #fff;
}

.contact-button {
  border-radius: 100px;
  background-color: #fff;
  color: #0f0f0f;
  border: none;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.contact-button:hover {
  background-color: #f0f0f0;
  transform: translateX(-4px);
}

.contact-button span {
  flex: 1;
}

.social-media {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  height: 24px;
  align-items: center;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #fff;
  transition: all 0.3s ease;
}

.social-link:hover {
  transform: translateY(-2px);
}

.social-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.social-icon.instagram {
  background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
}

.social-icon.twitter {
  background: #000;
}

.social-icon.youtube {
  background: #ff0000;
}

.social-icon.linkedin {
  background: #0077b5;
}

.social-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.social-name {
  font-size: 14px;
  font-weight: 500;
  height: 20px;
  display: flex;
  align-items: center;
}

.social-handle {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.7);
}

.social-handle::before {
  content: '@';
  opacity: 0.8;
}

/* Divider */
.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
}

/* Footer Links */
.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: center;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  transition: all 0.3s ease;
  opacity: 0.9;
}

.footer-link:hover {
  opacity: 1;
  text-decoration: underline;
}

/* Bottom Section */
.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.footer-logo {
  width: auto;
  height: 140px;
  object-fit: contain;
}

.footer-description {
  max-width: 800px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

/* Arabic RTL Support */
html[lang="ar"] .contact-button:hover {
  transform: translateX(4px);
}

html[lang="ar"] .social-handle::before {
  content: '';
}

html[lang="ar"] .social-handle::after {
  content: '@';
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer {
    padding: 48px 32px 32px;
  }

  .footer-top {
    flex-direction: column;
    gap: 40px;
  }

  .social-media {
    height: auto;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 20px 24px;
  }

  .footer-container {
    gap: 40px;
  }

  .contact-title {
    font-size: 32px;
  }

  .social-media {
    gap: 20px;
  }

  .footer-links {
    gap: 20px;
    text-align: center;
  }

  .footer-logo {
    height: 60px;
  }

  .footer-description {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 32px 16px 20px;
  }

  .contact-title {
    font-size: 24px;
  }

  .contact-button {
    padding: 10px 16px;
    font-size: 14px;
  }

  .social-media {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .footer-links {
    flex-direction: column;
    gap: 12px;
  }
}
</style>